import { isDevelopment, isLocalE2ETestMode } from "utils/environment";

const isDevServer = isDevelopment() && !isLocalE2ETestMode();
const isLocalEndToEndTests = isDevelopment() && isLocalE2ETestMode();

let urlPrefix = "";
if (isDevServer) {
  urlPrefix = "http://localhost:8001";
} else if (isLocalEndToEndTests) {
  urlPrefix = "http://localhost:8081";
}

const endpoints = {
  cable: `${urlPrefix}/backend/cable`,
  exportSchedule: `${urlPrefix}/backend/export-schedule`,
  graphql: `${urlPrefix}/backend/graphql`,
  login: `${urlPrefix}/backend/login`,
  logout: `${urlPrefix}/backend/logout`,
  switchSite: (id) => `${urlPrefix}/backend/switch-site/${id}`,
};

export default endpoints;
